import { useCallback } from 'react'
import { stringifyUrl } from '../helpers/router'
import { useRouter } from './useRouter'

interface IUseFacetsSubmit {
  (): {
    onSubmit: (slug: string) => (value: any) => void
  }
}

const useFacetsSubmit: IUseFacetsSubmit = () => {
  const router = useRouter()
  const { asPath, replace, query: params } = router

  const onSubmit = useCallback(
    (slug: string): ((value: any) => void) => {
      return (value: any): void => {
        console.log({
          params,
          isReady: router.isReady,
        })
        const result = {}
        const exclude: string[] = []
        const regExp = /[[]]/gm

        if (slug !== 'page') {
          exclude.push('page')
        }

        if (slug !== 'query') {
          exclude.push('query')
        }

        Object.keys(params).forEach((name) => {
          if (regExp.test(name)) {
            const i = name.replace(/[[]]/gm, '')

            if (Array.isArray(params[name])) {
              result[i] = params[name]
            } else {
              result[i] = [params[name]]
            }
          }
        })

        result[slug] = value

        replace(
          stringifyUrl(asPath, {
            set: {
              ...result,
            },
            exclude,
          }),
          undefined,
          {
            shallow: true,
          }
        )
      }
    },
    [asPath, params, replace]
  )

  return {
    onSubmit,
  }
}

export default useFacetsSubmit
